import { login, logout, getInfo, register } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    user: {
      id: 0,
      email: '',
      phone: '',
      name: '',
      rule: 0,
      enterprise_name: '',
      enterprise_status: 0,
      enterprise_field: '',
      enterprise_province_area_id: 0,
      enterprise_province_area_name: '',
      enterprise_city_area_id: 0,
      enterprise_city_area_name: '',
      enterprise_county_area_id: 0,
      enterprise_county_area_name: '',
      enterprise_number: 0,
      enterprise_type: '',
      enterprise_sec_type: '',
      post: '',
      enterprise_info: {},
      enterprise_info_type: 0,
      enterprise_purpose: '',
      enterprise_desc: '',
      enterprise_good_at: '',
      created_at: ''
    }
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER: (state, user) => {
    user.enterprise_province_area_id = user.enterprise_province_area_id == 0 ? '' : user.enterprise_province_area_id
    state.user = user
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { email, password, code, key } = userInfo
    return new Promise((resolve, reject) => {
      login({ email: email.trim(), password: password, code: code, key: key }).then(response => {
        const { token } = response
        commit('SET_TOKEN', token)
        setToken(token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  register({ commit }, userInfo) {
    const { email, password, code } = userInfo
    return new Promise((resolve, reject) => {
      register({ email: email.trim(), password: password, code: code }).then(response => {
        const { token } = response
        commit('SET_TOKEN', token)
        setToken(token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { user } = response

        commit('SET_USER', user)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      // logout(state.token).then(() => {
      removeToken() // must remove  token  first
      resetRouter()
      // commit('RESET_STATE')
      resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

